import { BaseModel } from './BaseModel';
import SubCategory from './SubCategory';
export class Category extends BaseModel {
  static get entity() {
    return 'categories';
  }

  static get fk() {
    return 'category_id';
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      slug: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null),
      sub_categories_ids: this.attr(null),
      sub_categories: this.hasManyBy(SubCategory, 'sub_categories_ids', 'category_id')
    };
  }

  static apiConfig = {
    actions: {
      async fetch(params = {}) {
        return this.get(`/categories`, { params });
      },

      async categories(params = {}) {
        const { response } = await this.fetch(params);

        return response.data.filter((category) => category.slug !== 'recommendation');
      },

      fetchByCategoryId(category_id) {
        return this.get(`/categories/${category_id}`);
      }
    }
  };
}

export default Category;
